import { render, staticRenderFns } from "./VRVestimateApproach.vue?vue&type=template&id=3ed05f18"
import script from "./VRVestimateApproach.vue?vue&type=script&lang=js"
export * from "./VRVestimateApproach.vue?vue&type=script&lang=js"
import style0 from "./VRVestimateApproach.vue?vue&type=style&index=0&id=3ed05f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports